import React, { useState } from "react";
import PropTypes from "prop-types";
import { dictToDraftRows, draftRowsToDict } from "../../utils/kvSimple.js";

/**
 * kv_simple 专用表单：componentData 为 { [key]: string }。
 * 内部用 draft 行支持空 key 临时行；onChange 始终回传不含空 key 的 dict。
 * 节点切换时由外层 key remount 重置 draft。
 */
function KvSimpleForm({ value, onChange, valueLabel, isEdit = true }) {
  const [rows, setRows] = useState(() => dictToDraftRows(value));

  const commit = (nextRows) => {
    setRows(nextRows);
    if (onChange) onChange(draftRowsToDict(nextRows));
  };

  const handleChange = (idx, field, nextVal) => {
    const next = rows.map((row, i) =>
      i === idx ? { ...row, [field]: nextVal } : row
    );
    commit(next);
  };

  const handleAdd = () => {
    commit([...rows, { key: "", val: "" }]);
  };

  const handleDelete = (idx) => {
    const next = [...rows];
    next.splice(idx, 1);
    commit(next);
  };

  return (
    <div>
      <table className="tfe-kv-table">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>键</th>
            <th style={{ width: "65%" }}>{valueLabel ?? "值"}</th>
            <th style={{ width: "5%" }} />
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td
                colSpan={3}
                style={{
                  padding: "24px",
                  textAlign: "center",
                  color: "#9ca3af",
                  fontStyle: "italic",
                }}
              >
                暂无配置，请添加
              </td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr key={idx}>
                <td>
                  <input
                    value={row.key ?? ""}
                    readOnly={!isEdit}
                    onChange={(e) => handleChange(idx, "key", e.target.value)}
                    placeholder="键入 '/' 键快速插入变量"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.val ?? ""}
                    readOnly={!isEdit}
                    onChange={(e) => handleChange(idx, "val", e.target.value)}
                    placeholder="键入 '/' 键快速插入变量"
                  />
                </td>
                <td>
                  {isEdit && (
                    <button
                      className="tfe-btn-del-row"
                      onClick={() => handleDelete(idx)}
                      aria-label="删除行"
                      type="button"
                    >
                      🗑
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {isEdit && (
        <button className="tfe-btn-add-row" onClick={handleAdd} type="button">
          + 添加参数行
        </button>
      )}
    </div>
  );
}

KvSimpleForm.propTypes = {
  /** 当前字典；非 plain object（含数组）按空表展示 */
  value: PropTypes.any,
  onChange: PropTypes.func,
  valueLabel: PropTypes.string,
  /** 是否允许编辑。默认 true。 */
  isEdit: PropTypes.bool,
};

export default KvSimpleForm;
